import { makeMed3, makeReg4 } from './textStyles';
const alertStyles = (tokens) => ({
    variants: {
        success: {
            container: {
                px: tokens.Spacing07,
                py: tokens.Spacing05,
                backgroundColor: tokens.SuccessLight,
                borderColor: tokens.BorderSuccess,
                borderBottomWidth: tokens.BorderWidth02,
            },
            description: makeReg4(tokens, {
                color: tokens.TextDark800,
            }),
            icon: {
                color: tokens.TextSuccess,
                alignSelf: 'start',
            },
            title: makeMed3(tokens, {
                color: tokens.TextDark800,
            }),
        },
        error: {
            container: {
                px: tokens.Spacing07,
                py: tokens.Spacing05,
                backgroundColor: tokens.ErrorLight,
                borderColor: tokens.BorderError,
                borderBottomWidth: tokens.BorderWidth02,
            },
            description: makeReg4(tokens, {
                color: tokens.TextDark800,
            }),
            icon: {
                color: tokens.TextError,
                alignSelf: 'start',
            },
            title: makeMed3(tokens, {
                color: tokens.TextDark800,
            }),
        },
        info: {
            container: {
                padding: tokens.Spacing05,
                backgroundColor: tokens.InformationLight,
                borderColor: tokens.BorderInformation,
                borderBottomWidth: tokens.BorderWidth02,
            },
            description: makeReg4(tokens, {
                color: tokens.TextDark800,
            }),
            icon: {
                color: tokens.TextInformation,
                alignSelf: 'start',
            },
            title: makeMed3(tokens, {
                color: tokens.TextDark800,
            }),
        },
        warning: {
            container: {
                padding: tokens.Spacing05,
                backgroundColor: tokens.WarningLight,
                borderColor: tokens.BorderWarning,
                borderBottomWidth: tokens.BorderWidth02,
            },
            description: makeReg4(tokens, {
                color: tokens.TextDark800,
            }),
            icon: {
                color: tokens.TextWarning,
                alignSelf: 'start',
            },
            title: makeMed3(tokens, {
                color: tokens.TextDark800,
            }),
        },
    },
});
export default alertStyles;
